<template></template>

<script>
export default {
  props:{
    mainPageUrl: {
      type: String
    }
  },
  data(){
    return{
      landingMenuItems: [],
      landingSlugs: [],
      landingSectionsCoords: [],
      refuseScrollChangeMenuItemToThis: false,
    }
  },
  methods: {
    sortLandingCoords(a, b){
      if (a.pos > b.pos) {
        return 1;
      } else if (a.pos < b.pos) {
        return -1;
      }
      return 0;
    },
    updateLandingSectionsCoords(){
      this.landingSectionsCoords = [];
      let headerHeight = window.innerWidth < 1024 ? 56: 80;
      this.landingSlugs.forEach((item, i, arr) => {
        let block = document.getElementById(item+'-block');
        if(block){
          let coords = block.getBoundingClientRect();
          coords = coords.top + pageYOffset - headerHeight - 300; //300px part of previous block
          this.landingSectionsCoords.push({slug:item, pos: coords});
        }
      });
      this.landingSectionsCoords.sort(this.sortLandingCoords);
    },
    scrollToElement(idElement){
      this.clickMobileMenu(true);
      this.updateLandingSectionsCoords();
      const headerHeight = window.innerWidth < 1024 ? 56: 80;
      //console.log('scroll to '+ idElement);
      const block = document.getElementById(idElement);
      if(block){
        const coords = block.getBoundingClientRect();
        window.scrollTo({
          top: coords.top + pageYOffset - headerHeight,
          behavior: "smooth"
        });
      }
    },
    markCurrentMenuItem(slug){
      const activeItem = document.querySelector('.app-header__menu-item_active');
      if(activeItem) activeItem.classList.remove('app-header__menu-item_active');
      let newActiveEl;

      let itemLink = document.querySelector('.app-header__menu-list [href="'+this.mainPageUrl+'#'+slug+'"]');
      if(itemLink) newActiveEl = itemLink.closest(".app-header__menu-item");
      if(newActiveEl) newActiveEl.classList.add('app-header__menu-item_active');
    },
    landingMenuClick(e){
      if(window.location.pathname === this.mainPageUrl){
        const newHashValue = e.target.getAttribute("href").slice(4);
        window.location.hash = newHashValue;
        this.refuseScrollChangeMenuItemToThis = newHashValue;
        this.scrollToElement(newHashValue+'-block');
        this.markCurrentMenuItem(newHashValue);
        e.preventDefault();
        return false;
      }
    },
    clickMobileMenu(closeOnly){
      const cssClassActiveMenu = 'app-header__menu-block_show-mobile';
      const menuBlock = document.querySelector('.'+cssClassActiveMenu)
      if(menuBlock){
        menuBlock.classList.remove(cssClassActiveMenu); //remove active from menu
      }else{
        if(closeOnly!==true) document.querySelector("body").classList.add(cssClassActiveMenu); //add active from content
      }
    },
    checkActualMarkItemMenu(){

      if(window.location.pathname !== this.mainPageUrl) return false; //refuse action on other pages except main

      let newActiveItem = null;

      this.landingSectionsCoords.every(function(item, i, arr) {
        //console.log(pageYOffset,item.pos)
        if(pageYOffset < item.pos) return false;
        newActiveItem = item.slug;
        return true;
      });

      if(this.refuseScrollChangeMenuItemToThis) {
        if(this.refuseScrollChangeMenuItemToThis === newActiveItem) this.refuseScrollChangeMenuItemToThis = false;
      }else{
        this.markCurrentMenuItem(newActiveItem);
      }
    }
  },
  mounted(){
    //Mobile menu Init
    const menuBtn = document.querySelector(".app-header__menu-button");
    if(menuBtn){
      document.querySelector(".app-header__menu-button").addEventListener('click', this.clickMobileMenu, false);
      document.querySelector(".app-header__mobile-close").addEventListener('click', this.clickMobileMenu, false);
    }

    if(window.location.pathname !== this.mainPageUrl) return false;

    //Landing Links Init
    this.landingMenuItems = document.getElementsByClassName("e-js-landing-scroll");
    if(!this.landingMenuItems) return false;

    for (let i = 0; i < this.landingMenuItems.length; i++) {
      this.landingMenuItems[i].addEventListener('click', this.landingMenuClick, false);
      this.landingSlugs.push(this.landingMenuItems[i].getAttribute("href").slice(4));
    }

    this.updateLandingSectionsCoords();

    if(window.location.hash) {
      let hashSlug = window.location.hash.slice(1);
      this.refuseScrollChangeMenuItemToThis = hashSlug;
      this.scrollToElement(hashSlug+'-block');
      this.markCurrentMenuItem(hashSlug);
    }


    window.addEventListener('resize', this.updateLandingSectionsCoords);
    window.addEventListener('scroll', this.checkActualMarkItemMenu);
  },
}
</script>

<style scoped>

</style>
